module.exports = __webpack_public_path__ + "static/img/banner-fixed-old.557567a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-fixed-old.jpg
// module id = Y9BZ
// module chunks = 1